<template>
  <div class="content">
    <el-row type="flex" justify="start">
      <el-col :span="16">
        <el-form
          label-position="top"
          label-width="200px"
          ref="form"
          :rules="rules"
          :model="form"
        >
          <h3>安心奖励</h3>
          <div>
            <el-row type="flex" justify="center">
              <el-col>
                <h3 class="text-center">
                  每个VIP等级对Welfare bonus的收益上限
                </h3>
              </el-col>
            </el-row>

            <el-table
              :data="form.configs"
              border
              style="width: 100%"
              @cell-mouse-enter="handleCellEnter"
              @cell-mouse-leave="handleCellLeave"
            >
              <el-table-column prop="date" label="VIP等级" width="170">
                <template slot-scope="scope">
                  {{ scope.row.name }}
                </template>
              </el-table-column>
              <el-table-column prop="date" label="奖励上限">
                <template slot-scope="scope">
                  <el-input
                    class="item"
                    type="number"
                    v-model="scope.row.welfare_bonus_reward_limit"
                    placeholder="请输入1-100正整数"
                  >
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="date" label="RP积分上限">
                <template slot-scope="scope">
                  <el-input
                    class="item"
                    type="number"
                    v-model="scope.row.welfare_bonus_reward_rp_limit"
                    placeholder="请输入"
                  >
                  </el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-col :span="24">
            <h3>Welfare Bonus:</h3>
            <el-form-item
              prop="welfare_bonus_effective_child_nodes_reward_money"
            >
              <el-row type="flex" justify="start">
                <el-col :span="16">
                  <el-input
                    type="number"
                    v-model="
                      form.welfare_bonus_effective_child_nodes_reward_money
                    "
                    placeholder="请输入1-100正整数"
                  >
                    <template slot="prepend">有效子节点的奖励金额 =</template>
                    <template slot="append">美金</template>
                  </el-input>
                </el-col>
                <el-col :span="2"><div class="text-c">+</div></el-col>
                <el-col :span="10">
                  <el-input
                    type="number"
                    v-model="form.welfare_bonus_effective_child_nodes_reward_rp"
                    placeholder="请输入"
                  >
                    <template slot="append">RP积分</template>
                  </el-input></el-col
                >
              </el-row>
            </el-form-item>
          </el-col>
          <el-col>
            <el-row type="flex" justify="center">
              <el-form-item>
                <el-button
                  type="primary"
                  @click="saveConfigs"
                  :loading="btnLoading"
                >
                  保存
                </el-button>
              </el-form-item>
            </el-row>
          </el-col>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      btnLoading: false,
      rules: {
        welfare_bonus_effective_child_nodes_reward_rp: [
          { required: true, message: '请填写', trigger: 'change' },
        ],
        welfare_bonus_effective_child_nodes_reward_money: [
          { required: true, message: '请填写', trigger: 'change' },
        ],
      },
      form: {
        welfare_bonus_effective_child_nodes_reward_rp: '',
        welfare_bonus_effective_child_nodes_reward_money: '',
        configs: [],
      },
    }
  },
  mounted() {
    this.configs()
  },
  methods: {
    /** 鼠标移入cell */
    handleCellEnter(row, column, cell, event) {
      row.isEdit = true
    },
    /** 鼠标移出cell */
    handleCellLeave(row, column, cell, event) {
      row.isEdit = false
    },
    configs() {
      request({
        url: '/api/backend/rewardConfig/welfareBonusConfigs',
        method: 'get',
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.form = {
            ...res.data,
            welfare_bonus_effective_child_nodes_reward_money:
              res.data.welfare_bonus_effective_child_nodes_reward_money,
          }
          console.log(this.form)
        }
      })
    },

    saveConfigs() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/rewardConfig/saveWelfareBonusConfigs',
            method: 'post',
            data: {
              welfare_bonus_effective_child_nodes_reward_rp:
                this.form.welfare_bonus_effective_child_nodes_reward_rp,
              welfare_bonus_effective_child_nodes_reward_money:
                this.form.welfare_bonus_effective_child_nodes_reward_money,
              configs: this.form.configs,
            },
          })
            .then((response) => {
              this.btnLoading = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
  },
}
</script>

<style>
.content {
  padding: 20px;
}
.text-center {
  text-align: center;
}
</style>
